<template>
  <div class="viewer-website" ref="frame" tabindex="-1">
    <div id="player" class="youtube-player" v-if="getIsYouTube"></div>
    <iframe
      class="viewer-website__website"
      :src="getUrl(src)"
      ref="iframe"
      tabindex="-1"
      v-else
    ></iframe>
  </div>
</template>

<script>
import { KEYS } from '@/mixins/keyHandler';
import router from '@/router';
import { queryAssembler } from '@/mixins/queryAssembler';

// Abstand zwischen zwei Fokus-Rueckholungen.
//
// Eine Seite, die ihren Fokus mit einem eigenen focusout-Handler verteidigt
// (genau das tun modale Cookie-Dialoge), wuerde sich sonst mit uns in einer
// engen Schleife um den Fokus streiten - und die frisst den Main-Thread, also
// genau das, was hier verhindert werden soll.
const FOCUS_RECLAIM_MIN_MS = 250;

// Zusaetzliche, langsame Kontrolle. Faengt die Faelle, in denen kein
// focusin-Ereignis kommt (aeltere WebKit-Builds auf Orsay/WebOS 3.x).
const FOCUS_GUARD_MS = 1000;

export default {
  mixins: [queryAssembler],
  props: {
    src: {
      type: String,
    },
    scrollPosition: {
      type: Number,
      default: 0,
    },
  },
  mounted() {
    this.$eventBus.$on('key-handler', (context) => {
      if (this.getIsYouTube) {
        this.handleYoutubeKeys(context);
      }
      const keysObject = [
        'code',
        'key',
        'keyCode',
        'timeStamp',
        'type',
        'bubbles',
      ];
      const eventObject = keysObject.reduce((ret, it) => {
        const res = ret;
        res[it] = context[it];
        return res;
      }, {});
      // console.log(e);
      if (this.$refs.iframe) {
        this.$refs.iframe.contentWindow.postMessage(eventObject, '*');
      }
    });
    if (this.src.includes('youtube') || this.src.includes('youtu.be')) {
      this.handleYoutubePlayer();
    }
    // Fokus-Waechter. Siehe reclaimFocus - ohne ihn kann eine eingebettete
    // Seite die Fernbedienung der TV-App komplett stilllegen.
    document.addEventListener('focusin', this.onFocusIn);
    this.focusGuard = setInterval(this.reclaimFocus, FOCUS_GUARD_MS);
  },
  data() {
    return {
      player: null,
      done: false,
      isPlaying: false,
      focusGuard: null,
      lastFocusReclaim: 0,
    };
  },
  methods: {
    getUrl(src) {
      return this.assembleUrl(src);
    },
    onFocusIn() {
      this.reclaimFocus();
    },
    // Holt den Fokus aus dem iframe zurueck in unser Dokument.
    //
    // Der Grund: die Tasten der Fernbedienung kommen als keydown-Ereignisse im
    // Dokument des FOKUSSIERTEN Elements an. Zieht die eingebettete Seite den
    // Fokus zu sich - ein modaler Cookie-Hinweis tut genau das -, laufen alle
    // Tastendruecke ins iframe, und der keydown-Listener der TV-App auf window
    // sieht nichts mehr. BACK und HOME sind dann tot. Ueber die Origin-Grenze
    // bubbelt kein Ereignis, es gibt also keine Moeglichkeit, sie dort
    // abzufangen - der Fokus muss auf unserer Seite bleiben.
    //
    // document.activeElement ist im Elterndokument das iframe-ELEMENT, sobald
    // der Fokus irgendwo darin liegt. Mehr gibt die Origin-Grenze nicht her,
    // aber mehr braucht es auch nicht.
    //
    // Fuer die eigenen Info-App-Widgets aendert sich nichts: die bekommen ihre
    // Tasten ueber postMessage (siehe den key-handler-Listener oben) und nicht
    // ueber den Fokus.
    reclaimFocus() {
      const iframe = this.$refs.iframe;
      if (!iframe || document.activeElement !== iframe) return;
      const now = Date.now();
      if (now - this.lastFocusReclaim < FOCUS_RECLAIM_MIN_MS) return;
      this.lastFocusReclaim = now;
      console.log('[WebViewer] Fokus lag im iframe - zurueckgeholt');
      try {
        iframe.blur();
      } catch (e) {
        /* manche Firmwares werfen hier - dann hilft das focus() darunter */
      }
      const frame = this.$refs.frame;
      if (!frame) return;
      try {
        frame.focus();
      } catch (e) {
        /* nicht fokussierbar - dann liegt der Fokus auf body, das genuegt */
      }
    },
    handleYoutubeKeys({ key, event }) {
      switch (key) {
        case KEYS.ENTER:
          if (!this.isPlaying) {
            this.player.playVideo();
            this.isPlaying = true;
          } else {
            this.player.pauseVideo();
            this.isPlaying = false;
          }

          console.log(this.player);
          break;
        case KEYS.RIGHT:
          this.handleSeekEvent('next');
          break;
        case KEYS.LEFT:
          this.handleSeekEvent('prev');
          break;
      }
    },
    handleSeekEvent(direction) {
      const duration = this.player.getCurrentTime();
      console.log('DURATION', duration);

      switch (direction) {
        case 'next':
          this.player.seekTo(duration + 15);
          break;
        case 'prev':
          this.player.seekTo(duration - 15 > 0 ? duration - 15 : 0);
          break;
      }
    },
    onPlayerReady(context) {
      context.target.playVideo();
      this.isPlaying = true;
    },
    onStateChange(context) {
      console.log('STATE CHANGE', context);
      if (context.data === YT.PlayerState.ENDED) {
        router.go(-1);
      }
      // if (context.data == YT.PlayerState.PLAYING && !this.done) {

      // }
    },
    assignYoutubePlayer() {
      this.player = new YT.Player('player', {
        height: '100%',
        width: '100%',
        videoId: this.getYoutTubeId,
        events: {
          onReady: this.onPlayerReady,
          onStateChange: this.onStateChange,
        },
      });
    },
    handleYoutubePlayer() {
      const iframeAPI = document.getElementById('yt-iframe-api');
      if (!iframeAPI) {
        const tag = document.createElement('script');
        tag.src = 'https://www.youtube.com/iframe_api';
        tag.id = 'yt-iframe-api';
        // const firstScriptTag = document.getElementsByName('script')[0];
        // console.log(firstScriptTag);
        // firstScriptTag.parentNode.ins(tag, firstScriptTag);
        document.body.appendChild(tag);
        window.onYouTubeIframeAPIReady = () => {
          this.assignYoutubePlayer();
        };
      } else {
        this.assignYoutubePlayer();
      }
    },
  },
  beforeDestroy() {
    this.$eventBus.$off('key-handler');
    document.removeEventListener('focusin', this.onFocusIn);
    if (this.focusGuard) {
      clearInterval(this.focusGuard);
      this.focusGuard = null;
    }
  },
  computed: {
    getIsYouTube() {
      if (this.src.includes('youtube')) return true;
      return false;
    },
    getYoutTubeId() {
      if (!this.getIsYouTube) return '';
      const arr = this.src.split('/');
      const id = arr[arr.length - 1].split('?')[0];
      return id;
    },
  },
};
</script>

<style scoped>
.viewer-website {
  height: 100vh;
  position: relative;
  width: 100vw;
}
/* Der Wrapper ist nur fokussierbar, damit der Fokus-Waechter ihn als Ziel hat -
   sichtbar werden soll das nicht. */
.viewer-website:focus {
  outline: none;
}
.viewer-website__website {
  border: 0;
  height: 100%;
  position: absolute;
  /* pointer-events: none; */
  top: 0;
  transition: all 0.3s ease;
  width: 100%;
}

.youtube-player {
  height: 100vh;
  width: 100vw;
}
</style>



// WEBPACK FOOTER //
// src/components/WebViewer.vue